import { IcArrowTriangleFilled } from '@assets/icons/24x24';
import { Box, Icon, Select, useSelectContext, useSlotRecipe } from '@chakra-ui/react';
import { forwardRef } from 'react';

interface CustomSelectIndicatorProps {
  portalPlacement: 'top' | 'bottom';
  orientation?: 'top' | 'bottom';
  size: 'sm' | 'md' | 'lg';
  disabled: boolean;
}
const rotationMap = {
  bottom: {
    open: 'rotate(180deg)',
    closed: undefined,
  },
  top: {
    open: undefined,
    closed: 'rotate(180deg)',
  },
};

export const CustomIndicator = forwardRef<HTMLDivElement, CustomSelectIndicatorProps>(
  ({ orientation = 'bottom', portalPlacement, size, disabled }, ref) => {
    const { open } = useSelectContext();
    const actualOrientation = portalPlacement.startsWith('top')
      ? 'top'
      : portalPlacement.startsWith('bottom')
        ? 'bottom'
        : orientation;
    const state = open ? 'open' : 'closed';
    const rotation = rotationMap[actualOrientation][state];

    const recipe = useSlotRecipe({ key: 'select' });
    const styles = recipe({ size });

    return (
      <Select.IndicatorGroup data-active={open} data-disabled={disabled}>
        <Box ref={ref} transform={rotation} data-active={open} data-disabled={disabled} {...styles.indicator}>
          <Icon as={IcArrowTriangleFilled} color={disabled ? 'neutral.700' : 'neutral.white'} />
        </Box>
      </Select.IndicatorGroup>
    );
  },
);
